import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';
import { setupCountryCascade, setupCascade } from 'locations';
import { Settings } from 'settings.js.erb';

export default class extends Controller {
  static get targets() {
    return ['genericAddressTemplate'];
  } 

  connect(){
    this.updateTotals();
  }

  updateTotals(event) {
    var total = _.sumBy($(this.element).find('.or-total'), function(o) { return +$(o).val(); });
    var grossweight = _.sumBy($(this.element).find('.or-gross-weight'), function(o) { return +$(o).val(); });
    var netweight = _.sumBy($(this.element).find('.or-net-weight'), function(o) { return +$(o).val(); });
    var pricePerGram = total/netweight;
    
    $(this.element).find('#operation-total').html(formatMoney(total));
    $(this.element).find('#operation-gross-weight').html(formatWeight(grossweight)+' gr');
    $(this.element).find('#operation-net-weight').html(formatWeight(netweight)+' gr');
    $(this.element).find('#operation-price-per-gram').html(formatMoney(pricePerGram)+'/gr');
    $(this.element).find('#operation-insured-value').html(formatMoney(total*Settings.insured_value_multiplier));
    
    console.log('updateTotals', total, grossweight, netweight, pricePerGram);
  }
  
  showNewGenericAddress(event) {
    let placeType = $(this.element).find('.op-destination-place-type').val();
    let placeId = $(this.element).find('.op-destination-place-id').val();

    if (placeType == 'GenericAddress' && placeId=='') {
      console.log('showNewGenericAddress should show form');
      var contentText = this.genericAddressTemplateTarget.innerHTML.replace(/TMPL_ID/g, new Date().valueOf());
      var content = $(contentText);
      $(this.element).find('.op-destination-place-details').empty().append(content); 
      _.each(content.find('.country-select'), function(el){
        setupCountryCascade(el);
      });
      _.each(content.find('.province-select'), function(el){
        setupCascade(el)
      });
    } else {
      $(this.element).find('.op-destination-place-details').empty();
    } 
  }
}
